<template>
  <a-modal
    v-model="visible"
    width="60%"
    title="明细核销"
    :maskClosable="false"
    :destroyOnClose="true"
    :centered="true"
    @ok="onSubmit"
    :confirmLoading="confirmLoading"
  >
    <div>
      <data-grid
        ref="dataGrid"
        :columns="columns"
        v-model="data"
        bordered
        size="small"
        :props="{
          scroll: {
            y: 300
          }
        }"
      >
      </data-grid>

      <div class="title">
        <strong>付款方式</strong>
        <a-button
          style="margin-left:10px;"
          type="primary"
          size="small"
          icon="plus"
          @click="addRow()"
          >增加收款</a-button
        >
        <span style="float:right; "
          >总计：<em style="font-size:16px;color:#f00;font-style:normal"
            >￥{{ totalAmount }}</em
          ></span
        >
      </div>
      <div>
        <div class="cnt">
          <div>
            <table class="payTable">
              <thead>
                <tr style="background-color: #ffffeb;text-align: center;">
                  <td>付款方式</td>
                  <td>金额</td>
                  <td>单据号</td>
                  <td>备注</td>
                  <td></td>
                </tr>
              </thead>
              <tbody ref="payTable">
                <tr
                  style="background-color: white;"
                  v-for="(item, index) in writeOffData.PayWays"
                  :key="index"
                >
                  <td>
                    <a-select
                      style="width: 100%"
                      v-model="item.AccountItemId"
                      @change="onChangePayWay(index)"
                    >
                      <a-select-option
                        v-for="(item, index) in select.payway"
                        :key="index"
                        :value="item.Id"
                        :title="item.Name"
                        >{{ item.Name }}</a-select-option
                      >
                    </a-select>
                  </td>
                  <td>
                    <a-input-number
                      :min="0"
                      :max="writeOffAmount"
                      style="width: 100%"
                      @change="onChangeMoney"
                      v-model="item.WriteOffAmount"
                    />
                  </td>
                  <td>
                    <a-input v-model="item.No" />
                  </td>
                  <td>
                    <a-input v-model="item.Remark" />
                  </td>
                  <td>
                    <a-icon
                      class="del-icon"
                      type="minus-circle"
                      title="删除"
                      @click="delRow(index)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { DataGrid } from "@/components/dataGrid";
import { BankOrScanPayModal } from "@/views/orderManage/orderComponent/funtion.js";
import cloneDeep from "lodash/cloneDeep";
import calc from "@/utils/calc";
export default {
  name: "WriteOffDetail",
  props: {
    guestId: {
      type: String,
      default: ""
    },
    orderNo: {
      type: [String, Number],
      default: ""
    }
  },
  components: {
    DataGrid
  },
  data() {
    return {
      data: [],
      columns: [
        {
          title: "单据号",
          dataIndex: "BillNo",
          width: "15%"
        },
        {
          title: "挂账日期",
          dataIndex: "AccountDate",
          width: "15%"
        },
        {
          title: "账项",
          dataIndex: "AccountItemName"
        },
        {
          title: "操作员",
          dataIndex: "CreatorUserName",
          width: "15%"
        },
        {
          title: "未核金额",
          dataIndex: "UnWriteOffAmount",
          align: "right",
          width: "15%"
        }
      ],
      select: {}, //下拉数据
      writeOffData: {
        ReceivableDetailId: "",
        PayWays: []
      },
      visible: false,
      confirmLoading: false,
      totalAmount: 0, //计算付款方式总金额
      writeOffAmount: 0, //核销总额
      defaultItem: {}
    };
  },
  created() {
    this.getDefaultItem();
    this.$post("Account_GetReceivable").then(res => {
      this.select.payway = res.Data.filter(
        el =>
          !(
            (el.Attributes & 16777216) > 0 ||
            (el.Attributes & 134217728) > 0 ||
            (el.Attributes & 268435456) > 0
          )
      );
    });
  },
  methods: {
    //获取系统参数值
    getDefaultItem() {
      this.$post("Room_GetDefaultTime", {}).then(res => {
        res.Data.SystemConstList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });
      });
    },
    show(rows) {
      this.visible = true;
      this.data = rows;
      this.init();
    },
    init() {
      this.writeOffData.ReceivableDetailId = this.data[0].Id;
      this.writeOffData.PayWays = [];
      this.writeOffAmount = Number(this.data[0].UnWriteOffAmount);
      this.totalAmount = this.writeOffAmount;
      this.addRow(this.writeOffAmount);
    },
    onChangePayWay(index) {
      for (let i = 0; i < this.select.payway.length; i++) {
        const item = this.select.payway[i];
        if (item.Id == this.writeOffData.PayWays[index].AccountItemId) {
          this.writeOffData.PayWays[index].AccountItemName = item.Name;
        }
      }
      let paywayItem = this.select.payway.find(
        p => p.Id == this.writeOffData.PayWays[index].AccountItemId
      );
      if (
        ((paywayItem.Attributes & 131072) > 0 ||
          (paywayItem.Attributes & 262144) > 0) &&
        this.defaultItem.HuiyiPos == "1"
      ) {
        let title = "",
          payType = "";
        if ((paywayItem.Attributes & 131072) > 0) {
          title = "银行卡消费";
          payType = 1;
        } else if ((paywayItem.Attributes & 262144) > 0) {
          title = "扫码消费";
          payType = 2;
        }
        this.writeOffData.PayWays[index].Money = this.writeOffAmount;
        BankOrScanPayModal({
          title: title,
          payType: payType,
          isLimit: true,
          tipInfo: "注：支付成功后该笔款项将自动核销。",
          limitAmont: this.writeOffAmount,
          cannotChange: true,
          option: this.writeOffData.PayWays[index],
          PaySign: 3,
          defaultItem: this.defaultItem,
          orderId: this.guestId,
          orderNo: this.orderNo,
          update: data => {
            this.callBack(data, index, paywayItem);
          }
        });
      } else if ((paywayItem.Attributes & 2097152) > 0) {
        const payConfig = JSON.parse(this.defaultItem.AllInPayConfig);
        if (payConfig.status == 1) {
          const tit =
            (paywayItem.Attributes & 2097152) > 0
              ? "通联扫码"
              : "通联扫码预授权";
          const paiApi =
            (paywayItem.Attributes & 2097152) > 0
              ? "/api/AllInPayQrPay/Pay"
              : "/api/AllInPayPreQrPay/Pay";
          this.writeOffData.PayWays[index].Money = this.writeOffAmount;
          const payType = (paywayItem.Attributes & 2097152) > 0 ? 1 : 3;
          BankOrScanPayModal({
            title: tit,
            payType: payType,
            hasAuthCode: true,
            payApi: paiApi,
            isLimit: true,
            tipInfo: "注：支付成功后该笔款项将自动核销。",
            limitAmont: this.writeOffAmount,
            cannotChange: true,
            option: this.writeOffData.PayWays[index],
            PaySign: 3,
            defaultItem: this.defaultItem,
            orderId: this.guestId,
            orderNo: this.orderNo,
            update: data => {
              this.callBack(data, index, paywayItem);
            }
          });
        }
      }
    },
    callBack(data, index, paywayItem) {
      if (data) {
        const json = {
          ReceivableDetailId: this.writeOffData.ReceivableDetailId,
          PayWays: [
            {
              AccountItemId: paywayItem.Id,
              AccountItemName: paywayItem.Name,
              WriteOffAmount: data.payMoney,
              No: data.payBillNo,
              Remark: data.payRemark
            }
          ]
        };
        this.confirmLoading = true;
        this.$post("RecVa_DetailWriteOff", json)
          .then(() => {
            this.visible = false;
            this.$message.success("核销成功");
            this.$emit("reloadDetail");
            this.confirmLoading = false;
          })
          .catch(() => {
            this.confirmLoading = false;
            this.writeOffData.PayWays[index].AccountItemId = "";
          });
      } else {
        this.writeOffData.PayWays[index].AccountItemId = "";
      }
    },
    onChangeMoney() {
      this.totalAmount = 0; //重新计算
      this.writeOffData.PayWays.forEach((item, index) => {
        if (!item.WriteOffAmount) item.WriteOffAmount = 0;
        let headerTd = this.$refs.payTable.querySelectorAll("tr")[index]
          .children[1];
        this.$common.removeClass(headerTd, "shake");
        if (Number(item.WriteOffAmount) > Number(this.writeOffAmount)) {
          this.$common.addClass(headerTd, "shake");
          this.$message.error("大于总核销金额,请重新输入");
          // item.WriteOffAmount = 0;
        }
        // this.totalAmount = accAdd(this.totalAmount, item.WriteOffAmount);
        this.totalAmount = calc(this.totalAmount)
          .add(item.WriteOffAmount)
          .number(2);
      });
    },
    delRow(index) {
      this.writeOffData.PayWays.splice(index, 1);
      this.onChangeMoney();
    },
    addRow(money) {
      this.writeOffData.PayWays.push({
        AccountItemId: null,
        AccountItemName: "",
        WriteOffAmount: money ? money : 0,
        No: "",
        Remark: ""
      });
    },
    onSubmitBefore() {
      if (Number(this.totalAmount) <= 0) {
        this.$message.error("核销总金额不能小于等于0！");
        return false;
      }
      let payWays = cloneDeep(this.writeOffData.PayWays);
      if (payWays.length) {
        payWays = payWays.filter(el => Number(el.WriteOffAmount) > 0);
        const isValid =
          payWays.length &&
          payWays.some(
            item => Number(item.WriteOffAmount) > 0 && !item.AccountItemId
          );
        if (isValid) {
          this.$message.error("金额不为0时,付款方式必填！");
          return false;
        }
      }
      if (Number(this.totalAmount) != Number(this.writeOffAmount)) {
        this.$message.error(
          "付款金额总和必须等于待核销金额：" + this.writeOffAmount
        );
        return false;
      }
    },
    onSubmit() {
      let json = this.onSubmitBefore();
      if (json === false) return;
      const payWays = this.writeOffData.PayWays.filter(
        el => Number(el.WriteOffAmount) > 0
      );
      const param = {
        PayWays: payWays,
        ReceivableDetailId: this.writeOffData.ReceivableDetailId
      };
      this.confirmLoading = true;
      this.$post("RecVa_DetailWriteOff", param)
        .then(() => {
          this.visible = false;
          this.confirmLoading = false;
          this.$message.success("核销成功");
          this.$emit("reloadDetail");
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.title {
  font-size: initial;
  margin-top: 5px;
}
.cnt {
  border: 1px solid #eee;
  max-height: 250px;
  overflow: auto;
  border-top: 0;
}
.payTable {
  width: 100%;
  margin-bottom: 5px;
  tr {
    td {
      padding: 2px 1px;
      width: 10%;
    }
  }
}
@keyframes shake {
  0% {
    transform: scale(1.02);
    border-color: #f00;
  }
  25% {
    transform: scale(1.05);
    border-color: #f00;
  }
  50% {
    transform: scale(1);
    border-color: #f00;
  }
  75% {
    transform: scale(1.05);
    border-color: #f00;
  }
  100% {
    transform: scale(1);
    border-color: #d9d9d9;
  }
}
.shake /deep/ .ant-input-number {
  -webkit-animation: shake 1s;
  animation: shake 1s;
}
/deep/
  .ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
/deep/ .ant-table-bordered .ant-table-tbody > tr > td {
  padding: 2px 3px 0 3px !important;
}
.del-icon {
  color: #f00;
  font-size: 16px;
  margin-top: 5px;
  margin-left: 5px;
  cursor: pointer;
}
</style>
